var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DrawSettingTable',{ref:"DrawSettingTable",attrs:{"trStatus":_vm.trStatus,"columns":_vm.columns,"data":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }